import { LOCALES } from 'i18n/locales';

export const mapPreviewIntl = {
    [LOCALES.ENGLISH]: {
        'mapPreview.coordinates': 'Coordinates',
        'mapPreview.area': 'Area size',
        'mapPreview.zoom.in': 'Zoom in',
        'mapPreview.zoom.out': 'Zoom out',
        'mapPreview.attribution': 'Attribution',
        'mapPreview.attribution.information': 'Attribution information'
    },
    [LOCALES.WELSH]: {
        'mapPreview.coordinates': 'Cyfesurynnau',
        'mapPreview.area': 'Dimensiwn ardal',
        'mapPreview.zoom.in': 'Chwyddo i mewn',
        'mapPreview.zoom.out': 'Chwyddo allan',
        'mapPreview.attribution': 'Priodoli',
        'mapPreview.attribution.information': 'Gwybodaeth priodoli'
    }
};
